import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const SkipToMapLink = (_param)=> {
    var { onClick , text , href  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick",
        "text",
        "href"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: "locations-skip-to-map-link"
    }), /*#__PURE__*/ React.createElement("a", {
        onClick: onClick,
        href: href,
        className: "locations-skip-to-map-link__link"
    }, text));
};

export { SkipToMapLink as default };
//# sourceMappingURL=SkipToMapLink.js.map
